import React from 'react';
interface GoalLineProps {
  minutes: number;
  goal: number;
  reached: boolean;
}
export function GoalLine({
  minutes,
  goal,
  reached
}: GoalLineProps) {
  const percent = Math.min(100, Math.round(minutes / goal * 100));
  return <div className="mx-auto w-full max-w-[220px]" data-id="element-45" data-mp="2xfksvr7ht41u">
      <p className="text-center text-xs text-muted" data-id="element-46" data-mp="32dumvyhhdylv">
        {reached ? 'Daily goal reached.' : `${minutes} / ${goal} min today`}
      </p>
      <div role="progressbar" aria-label="Daily focus goal progress" aria-valuemin={0} aria-valuemax={goal} aria-valuenow={minutes} aria-valuetext={`${minutes} of ${goal} minutes`} className="mt-2 h-[3px] w-full overflow-hidden rounded-full bg-line" data-id="element-47" data-mp="24rovsle0ha4j">
        <div className="h-full rounded-full bg-coral transition-[width] duration-200 ease-calm" style={{
        width: `${percent}%`
      }} data-id="element-48" data-mp="2jgl2of4c0h3k" />
      </div>
    </div>;
}